/* tslint:disable */
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {HttpResponse} from '@angular/common/http';
import {Inject} from '@angular/core';
import {Injectable} from '@angular/core';
import {API_HOST} from '../api-host';
import {PostOrderCampaignsByIdVerifyResponse} from './post-order-campaigns-by-id-verify.response';
import {PostOrderCampaignsByIdVerifyRequest} from './post-order-campaigns-by-id-verify.request';
@Injectable()
export class OrderCampaignsVerifyGateway {
  constructor(private readonly _httpClient: HttpClient, @Inject(API_HOST) private readonly _apiHost: string) {}

  postOrderCampaignsByIdVerify(
    id: string,
    body: PostOrderCampaignsByIdVerifyRequest,
    options?: Parameters<HttpClient['request']>[2],
  ): Observable<PostOrderCampaignsByIdVerifyResponse> {
    return this._httpClient.request('post', this._apiHost + `/order_campaigns/${id}/verify`, {
      ...options,
      observe: 'body',
      body,
    });
  }
}
